import { useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { ShortcutInfo } from '@hooks'
import CloseIcon from '@mui/icons-material/Close'
import KeyboardIcon from '@mui/icons-material/Keyboard'
import { Dialog, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material'
import { ToggleButton } from '@ui/actions'
import { Box } from '@ui/structure'
import { useResultsSelection } from '@editorHooks'

export const ToggleShortcutInfoButton = () => {
  const [showShortcutInfo, setShowShortcutInfo] = useState(false)
  const isAnchorCalculationMode = useResultsSelection().activeMode === 'tensile-connectors-table'

  const handleShortcutInfoClick = () => {
    setShowShortcutInfo(prev => !prev)
  }

  useHotkeys(
    'shift+?',
    handleShortcutInfoClick,
    {
      enabled: !isAnchorCalculationMode,
    },
    [showShortcutInfo, isAnchorCalculationMode],
  )

  return (
    <>
      <ToggleButton
        hint="Shortcut Info (?)"
        onClick={handleShortcutInfoClick}
        selected={showShortcutInfo}
        Icon={KeyboardIcon}
        data-cy="btn-show-shortcut-info"
      />
      <Dialog
        open={showShortcutInfo}
        onClose={() => setShowShortcutInfo(false)}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: 1200,
            maxWidth: 'calc(100vw - 32px)',
          },
        }}
      >
        <DialogTitle sx={{ pr: 6 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>Shortcuts</Box>
            <IconButton aria-label="Close" onClick={() => setShowShortcutInfo(false)} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ padding: 2, width: '100%' }}>
            <ShortcutInfo />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
